import {
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
  TimePickerProps
} from '@material-ui/pickers';
import React from 'react';
// import {DEFAULT_DATE_FORMAT} from '@shared/utils/DateTimeUtils';
import {TextFieldProps} from '@material-ui/core/TextField';
import {MaterialUiPickersDate} from '@material-ui/pickers/typings/date';
import {createStyles, makeStyles} from '@material-ui/core/styles';
import {GET_8_PIXEL_BOX} from '../../../style/variable';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

const useStyle = makeStyles(() =>
  createStyles({
    datePickerWrapperFormClass: {
      paddingBottom: `${GET_8_PIXEL_BOX(0)}`,
      marginBottom: '0',
      padding: '0px',
      display: 'contents'
    },
    root: {
      '& .MuiIconButton-root': {
        padding: '4px'
      }
    },
    accessTimeIcon: {
      fontSize: '19px',
      marginBottom: '2px'
      //   color: APP.COLOR.DEFAULT.BLACK
    }
  })
);

export interface TimePickerWrapperProps extends TimePickerProps {
  className?: string;
  inputClassName?: string;
  id?: string;
  placeHolder?: string;
  value: string | Date | null | undefined;
  onBlur?: TextFieldProps['onBlur'];
  onChange(date: MaterialUiPickersDate, value?: string | null): void;
}

const TimePickerWrapper = (
  props: TimePickerWrapperProps
): React.ReactElement => {
  const {
    className,
    inputClassName,
    placeHolder,
    id,
    value,
    onChange,
    onBlur,
    ...rest
  } = props;
  const classes = useStyle();
  const normalizedValue = value === undefined || value === '' ? null : value;
  return (
    <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment}>
      <KeyboardTimePicker
        autoOk
        variant="inline"
        className={[
          classes.datePickerWrapperFormClass,
          classes.root,
          className
        ].join(' ')}
        inputProps={{
          className: [inputClassName].join(' ')
        }}
        views={['hours', 'minutes']}
        inputVariant="outlined"
        margin={'dense'}
        orientation={'portrait'}
        PopoverProps={{
          anchorOrigin: {horizontal: 'left', vertical: 'bottom'},
          transformOrigin: {horizontal: 'left', vertical: 'top'}
        }}
        keyboardIcon={<AccessTimeIcon className={classes.accessTimeIcon} />}
        invalidDateMessage={''}
        id={id}
        placeholder={placeHolder}
        value={normalizedValue}
        onChange={onChange}
        onBlur={onBlur}
        {...rest}
        maxDateMessage={''}
        minDateMessage={''}
      />
    </MuiPickersUtilsProvider>
  );
};

export default TimePickerWrapper;
